<main class="flex min-h-screen">
  @if (isLoading()) {
    <app-spinner/>
  }
  <app-left-banner
    class="w-3/12 fixed h-screen short:overflow-y-scroll hidden"
    [ngClass]="{ 'hidebanner:block': showBanner()}"
  />
  <div class="flex flex-col w-full" [ngClass]="{ 'hidebanner:w-9/12 hidebanner:ml-auto': showBanner()}">
    @if (!isLogged() && showHeader()) {
      <app-header/>
    }
    @if (isLogged() && showHeader()) {
      <app-dashboard-header/>
    }
    <div class="flex-grow">
      <router-outlet />
    </div>
    @if(showFooter()){
      <app-footer/>
    }
    @if (showTostMessage()) {
      <app-toast [messageType]="getMessageType()" [message]="getMessage()"/>
    }
    @if (showModal()) {
      <app-information-prompt [messageType]="getModalType()" [message]="getModalMessage()"/>
    }
  </div>
</main>
